import React from 'react'
import { Route, Navigate, Routes } from 'react-router-dom'
import ProtectedRoute from 'auth/ProtectedRoute'

import Agenda from 'components/pages/Agenda'
import Sessions from 'components/pages/Sessions'
import CarsToBuy from 'components/pages/CarsToBuy'
import Assignment from 'components/pages/Assignment'
import PartnerInventory from 'components/pages/PartnerInventory'
import InventoryReprice from 'components/pages/InventoryReprice'
import Users from 'components/pages/Users'
import SessionsStepsRouter from 'components/pages/SessionsStepsRouter'
import Rules from 'components/pages/Rules'
import AssignmentStepsRouter from 'components/pages/AssignmentStepsRouter'
import CarsBookedRouter from 'components/pages/CarsBookedRouter'
import PartnerDocuments from 'components/pages/PartnerDocuments'

import MainTemplate from './components/templates/MainTemplate'
import LoginFlowTemplate from './components/templates/LoginFlowTemplate'

export default function MainRouter() {
  return (
    <Routes>
      <Route exact path="/" element={<Navigate to="/agenda" />} />
      <Route
        exact
        path="/agenda"
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <Agenda />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path="/sessions"
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <Sessions />
          </ProtectedRoute>
        }
      />

      {['/sessions/:id', '/sessions/:id/:step'].map((path, index) => (
        <Route
          key={index}
          exact
          path={path}
          element={
            <ProtectedRoute
              LoginFlowTemplate={LoginFlowTemplate}
              ProtectedTemplate={MainTemplate}
            >
              <SessionsStepsRouter />
            </ProtectedRoute>
          }
        />
      ))}
      {['/cars-to-buy/:partnerId', '/cars-to-buy'].map((path, index) => (
        <Route
          key={index}
          exact
          path={path}
          element={
            <ProtectedRoute
              LoginFlowTemplate={LoginFlowTemplate}
              ProtectedTemplate={MainTemplate}
            >
              <CarsToBuy />
            </ProtectedRoute>
          }
        />
      ))}

      {[
        '/cars-booked/:id/:partnerId/car-details/:plate',
        '/cars-booked/:id/:partnerId',
        '/cars-booked/:id/',
        '/cars-booked',
      ].map((path, index) => (
        <Route
          key={index}
          exact
          path={path}
          element={
            <ProtectedRoute
              LoginFlowTemplate={LoginFlowTemplate}
              ProtectedTemplate={MainTemplate}
            >
              <CarsBookedRouter />
            </ProtectedRoute>
          }
        />
      ))}

      {[
        '/assignment/:id/car-details/:plate',
        '/assignment/:id',
        '/assignment/:id/:step',
      ].map((path, index) => (
        <Route
          key={index}
          exact
          path={path}
          element={
            <ProtectedRoute
              LoginFlowTemplate={LoginFlowTemplate}
              ProtectedTemplate={MainTemplate}
            >
              <AssignmentStepsRouter />
            </ProtectedRoute>
          }
        />
      ))}

      <Route
        exact
        path={'/assignment'}
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <Assignment />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path="/partner-inventory"
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <PartnerInventory />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path="/inventory-reprice"
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <InventoryReprice />
          </ProtectedRoute>
        }
      />

      {['/rules', '/rules/:sessionId'].map((path, index) => (
        <Route
          key={index}
          exact
          path={path}
          element={
            <ProtectedRoute
              LoginFlowTemplate={LoginFlowTemplate}
              ProtectedTemplate={MainTemplate}
            >
              <Rules />
            </ProtectedRoute>
          }
        />
      ))}

      <Route
        exact
        path="/users"
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <Users />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path="/user-documents"
        element={
          <ProtectedRoute
            LoginFlowTemplate={LoginFlowTemplate}
            ProtectedTemplate={MainTemplate}
          >
            <PartnerDocuments />
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}
